import styled from "styled-components";

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  height: 50px;
`;

export const FiltersLeftContent = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  & > div:first-child {
    width: auto;
  }
`;

export const FiltersRightContent = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
`;

